import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-found-crm',
    templateUrl: './not-found-crm.component.html',
    styleUrls: ['./not-found-crm.component.css'],
    standalone: false
})
export class NotFoundCrmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
